import { Constants, DtoKeys, Helpers } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';
import { createDate } from '@/utils/date';
import { GridSortType } from '@/ui-kit/components/grid/enums';
import FilterMapper from '@/components/features/listing-search/mappers/filter';
import {
  EXCLUDED_COMMUNITY_NONE_VALUE,
} from '@/components/page-specific/listing/summary/constants';

const { SearchListingFilterDtoKey, NewListingDtoKey } = DtoKeys;

const DEFAULT_RADIX = 10;
const DEFAULT_LISTINGS_SEARCH_LIMIT = 20;
const ADDRESS_SEPARATOR = ',';
const ALL_DATE_RANGE_SYMBOL = '+';
const DEFAULT_SORTING = {
  orderBy: NewListingDtoKey.CLOSED_AT,
  order: GridSortType.Desc,
};

export default class ApiQueryMapper {
  static mapFilterToQuery(filterValue) {
    const minClosedAtValue = this.getMinClosedAtDate(filterValue[QueryParams.TransactionDate]);
    return {
      pagination: { pageSize: 10000 },
      filters: Helpers.ObjectHelper.removeEmptyProperties({
        [SearchListingFilterDtoKey.LOCATION]: FilterMapper.getLocation(filterValue),
        [SearchListingFilterDtoKey.CITY]: filterValue[QueryParams.City],
        [SearchListingFilterDtoKey.COMMUNITY]: (
          filterValue[QueryParams.Community] === EXCLUDED_COMMUNITY_NONE_VALUE
            ? undefined
            : filterValue[QueryParams.Community]
        ),
        [SearchListingFilterDtoKey.CLOSED_AT]: minClosedAtValue && {
          min: minClosedAtValue,
        },
      }),
      sorting: DEFAULT_SORTING,
    };
  }

  static mapSearchStringToQuery(searchString) {
    return {
      pagination: {
        pageSize: DEFAULT_LISTINGS_SEARCH_LIMIT,
      },
      filters: {
        [SearchListingFilterDtoKey.SEARCH]: this.#cleanupSearchString(searchString),
      },
      sorting: DEFAULT_SORTING,
    };
  }

  static mapSearchToQuery(searchValue) {
    return {
      pagination: {},
      filters: {
        [SearchListingFilterDtoKey.ADDRESS_ID]: parseInt(searchValue[QueryParams.AddressId], 10),
      },
      sorting: DEFAULT_SORTING,
    };
  }

  static getMinClosedAtDate(transactionDate) {
    const transactionDateIncludedValue = transactionDate
      .includes(Constants.DateUnit.Month) ? Constants.DateUnit.Month : Constants.DateUnit.Year;

    return transactionDate.includes(ALL_DATE_RANGE_SYMBOL)
      ? null
      : createDate()
        .subtract(
          parseInt(transactionDate, DEFAULT_RADIX),
          transactionDateIncludedValue,
        )
        .valueOf();
  }

  static #cleanupSearchString(searchString) {
    const [resultSearchString] = searchString.split(ADDRESS_SEPARATOR);

    return resultSearchString;
  }
}
